<style>
	.padd-width{
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 24px 0px;
	}
	.fins-card{
		width: 360px;
		margin-top: 27px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 18px;
		color: #666666;
		text-align: center;
		font-style: normal;
		text-transform: none;
	}
	.Example{
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 18px;
		color: #333333;
		text-align: center;
		font-style: normal;
		text-transform: none;
		margin-top: 16px;
	}
</style>
<template>
	<div>
		<Hrader :idShwo="2" @skipCompents="landingClcik"></Hrader>
		<div style="height: 70px"></div>
		<Popup :image="imageList" @membMoube="membMoubeClick" v-show="showImage"></Popup>
		<div>
			<img src="@/assets/recycling_slices/Mask group@2x.png" style="width: 100%; height: auto" />
		</div>
		<div class="rectangle" style="margin-top: -4px">
			<div class="rectangle-with">
				<div class="flex-rectange">
					<div>
						<img src="../../assets/recycling_slices/Vector@2x.png" style="width: 12px; height: 13px" />
					</div>
					<div class="current-recy">当前位置 : 卡券回收</div>
				</div>
			</div>
		</div>

		<div class="select-card-type">
			<div class="submission-notes">
				<!-- style="align-items: center" -->
				<div class="flex-submiss-notes">
					<div class="card-title-type" style="margin-top: 12px;">选择卡类</div>
					<div class="flex-card-type-warp">
						<div class="select-recycling-type" :class="{ 'select-recycling-type1': ids == item.id }" @click="seletcClick(item.id)" v-for="(item, index) in marListRef" :key="index">
							<img :src="item.coverImg" style="width: 18px; height: 18px" />
							<div class="card-title" style="white-space: nowrap;" :class="{ 'card-title1': ids == item.id }">{{ item.name }}</div>
						</div>
					</div>
				</div>
				<div class="border-top-card"></div>
				<div class="flex-submiss-notes">
					<div class="card-title-type">选择卡类</div>
					<div class="flex-card-type" style="margin-left: -2px; margin-top: -14px; align-items: flex-start">
						<div
							class="card-recycling"
							@click="paddlickey(index)"
							style="padding-bottom: 8px; width: 130px position: relative;"
							:class="{ 'card-recycling1': idst == index }"
							v-for="(item, index) in dataListSkip"
							:key="index"
						>
							<div class="fold-card" v-if="item.hotDes">{{ item.hotDes.slice(0, 4) }}折</div>
							<div style="margin-top: 3px">
								<img :src="item.coverImg" class="vimage" style="width: 65px; height: 42px" />
							</div>
							<div class="voctor-detach" style="font-size: 14px" :class="{ 'voctor-detach1': idst == index }">{{ item.name }}</div>
						</div>
					</div>
				</div>

				<div class="border-top-card"></div>
				<div class="flex-submiss-notes">
					<div class="card-title-type">
						<div class="card-single">单张面值</div>
						<div class="card-make">不得选错</div>
					</div>
					<div class="flex-card-type" style="margin-left: -2px; margin-top: -14px">
						<div
							class="card-recycling"
							style="height: 77px; display: flex; flex-direction: column; justify-content: center"
							:class="{ 'card-recycling1': indexids == index }"
							v-for="(item, index) in cardDetails"
							:key="index"
							@click="recyClick(index)"
						>
							<div class="card-price" style="font-size: 19px" :class="{ 'card-price1': indexids == index }" v-if="item.name != '自定义'">
								<spa style="font-size: 12px">￥</spa>
								{{ item.name }}
							</div>
							<div class="card-price" v-else>
								<input placeholder="请输入金额" v-model="price" type="number" class="inputSarpt" @blur="inpuSarptPlace" placeholder-class="placeholder" style="margin-left: 20px" />
							</div>
							<div class="flex-price" v-if="item.recycleRate">
								<!-- <div class="flex-fold">{{ item.recycleRate }}折</div> -->
								<div class="flex-fold">{{ item.rate }}折</div>
								<!-- <div class="flex-fold">{{ handleCutZero(handleCutZero(item.price)/handleCutZero(item.name)) }}折</div> -->
								<div class="bordr-fold">|</div>
								<div class="font-fold">￥{{ handleCutZero(item.price) }}</div>
							</div>
						</div>
					</div>
				</div>

				<div class="border-top-card"></div>
				<div class="flex-submiss-notes" style="align-items: center">
					<div class="card-title-type">
						<div class="card-single">提交方式</div>
					</div>
					<div class="flex-card-type" style="margin-left: -2px; margin-top: -14px">
						<div
							class="card-recycling"
							style="height: 56px; display: flex; flex-direction: column; justify-content: center"
							:class="{ 'card-recycling1': index == indexsT }"
							v-for="(item, index) in dataList"
							:key="index"
							@click="flexCardType(index)"
						>
							<div class="card-price-title" :class="{ 'card-price-title1': index == indexsT }">
								{{ item.title }}
							</div>
						</div>
					</div>
				</div>
				<div class="flex-submiss-notes" style="align-items: center; margin-top: 16px">
					<div class="card-title-type"></div>
					<div class="flex-card-type" style="margin-left: -2px; margin-top: -14px">
						<div class="card-text-price" v-if="text">
							<div style="padding: 12px" v-html="formatCardDes(text)"></div>
						</div>
					</div>
				</div>

				<template v-if="hasEnd === 1">
					<div class="border-top-card"></div>
					<div class="flex-submiss-notes" style="margin-top: 10px">
						<div class="card-title-type">
							<div class="card-single">有效时间</div>
						</div>
						<div class="flex-card-type" style="margin-left: 21px; margin-top: -14px">
							<el-date-picker v-model="state.model.endDate" type="date" placeholder="请输入有效时间" :default-value="new Date(2010, 9, 1)" />
						</div>
					</div>
				</template>

				<template v-if="indexsT == 0">
					<div class="border-top-card"></div>
					<div class="flex-submiss-notes">
						<div class="card-title-type">
							<div class="card-single">卡号/密码</div>
						</div>
						<div class="flex-card-type border-width" style="padding: 0; margin-left: 21px;">
							<textarea v-model="state.model.batchCodes" @blur="organizeClick1" @input="batchCodeChange" class="textarea" placeholder="请输入卡号 卡密"></textarea>
							<div class="margin-width">
								<div class="padd-width">
									<img  src="../../assets/login-account/Vector@2x (23).png" style="width: 68px; height: 86px;"/>
									<div class="fins-card">卡号与卡密之间请用英文或者中文空格隔开， 每张卡占用一行用“回车键”隔开，例如：</div>
							    <div class="Example">11789220866197996 221012233248664684</div>
								</div>
							</div>
						</div>
					</div>

					<!-- <div class="flex-submiss-notes" style="margin-top: 18px">
						<div class="card-title-type"></div>
						<div class="flex-card-type" style="margin-left: -2px; margin-top: -14px">
							<div class="card-text-price">
								<div style="padding: 12px">卡号之间请用 “空格” 隔开；每张卡占用“一行”，用“回车 (Enter键)”隔开。</div>
							</div>
						</div>
					</div> -->

					<div class="flex-submiss-notes" style="margin-left: 23px; margin-top: 32px">
						<div class="card-title-type"></div>
						<div class="flex-card-type" style="margin-left: -2px; margin-top: -14px">
							<div class="flex-card-margin" @click="organizeClick">整理卡号密码</div>
							<div class="flex-card-text">
								已经输入
								<span class="text-span">{{ state.model.codes.length }}</span>
								张面值
								<span class="text-span" v-if="price">{{ price }}元</span>
								<span class="text-span" v-else>{{ cardDetails[indexids]?.name || 0 }}元</span>
								的
								<span class="text-span">{{ dataListSkip[idst]?.name }}</span>
								，每次最多可提交100张
							</div>
						</div>
					</div>
				</template>

				<template v-if="indexsT == 1">
					<div class="border-top-card"></div>
					<div class="flex-submiss-notes" v-if="dataListSkip[idst]?.hasPwd == 1">
						<div class="card-title-type">
							<div class="card-single">卡劵号码</div>
						</div>
						<div class="flex-card-type" style="margin-left: 21px; margin-top: -14px">
							<input type="text" @input="batchCodeChangeCode" v-model="state.model.code" class="input" placeholder="请输入卡劵号码" />
						</div>
					</div>
					<div style="margin-top: 20px" v-if="dataListSkip[idst]?.hasPwd == 1"></div>
					<div class="flex-submiss-notes">
						<div class="card-title-type">
							<div class="card-single">卡劵密码</div>
						</div>
						<div class="flex-card-type" style="margin-left: 21px; margin-top: -14px">
							<input type="type" @input="batchCodeChangePwd" v-model="state.model.pwd" class="input" placeholder="请输入卡劵密码" />
						</div>
					</div>
				</template>

				<div class="flex-submiss-notes" style="align-items: center; margin-top: 16px">
					<div class="card-title-type"></div>
					<div class="flex-card-type" style="margin-left: -2px; margin-top: -14px">
						<div class="card-text-price">
							<div style="padding: 12px">{{ ruleDes }}</div>
						</div>
					</div>
				</div>

				<div class="border-top-card"></div>
				<div class="flex-submiss-notes" style="align-items: center">
					<div class="card-title-type" style="width: 8%">
						<div class="card-single"></div>
					</div>
					<div class="flex-card-type" style="align-items: center; margin-left: 8px; margin-top: -14px">
						<div class="flex-slice" :class="{ 'flex-slice1': flon }" @click="flonClick(1)">
							<img src="@/assets/recycling_slices/Slice 14@2x(1).png" style="width: 12px; height: 12px" />
						</div>
						<div class="have-read" @click="Jump">
							我已阅读，理解并接受
							<span style="color: #ff3333">「京卡收礼品卡转让协议」</span>
							和
							<span style="color: #ff3333">「礼品卡回收说明」</span>
						</div>
					</div>
				</div>

				<div class="flex-submiss-notes" style="margin-top: 16px; align-items: center">
					<div class="card-title-type" style="width: 8%">
						<div class="card-single"></div>
					</div>
					<div class="flex-card-type" style="align-items: center; margin-left: 8px; margin-top: -14px">
						<div class="flex-slice" :class="{ 'flex-slice1': flon2 }" @click="flonClick(2)">
							<img src="@/assets/recycling_slices/Slice 14@2x(1).png" style="width: 12px; height: 12px" />
						</div>
						<div class="have-read">
							我已确认该卡号、卡密来源合法
							<span style="color: #ff2f17">如有问题,本人愿意承担一切法律责任</span>
						</div>
					</div>
				</div>

				<div class="flex-submiss-notes" style="margin-top: 16px; align-items: center">
					<div class="card-title-type" style="width: 8%">
						<div class="card-single"></div>
					</div>
					<div class="flex-card-type" style="align-items: center; margin-left: 8px; margin-top: -14px">
						<div class="flex-slice" :class="{ 'flex-slice1': flon3 }" @click="flonClick(3)">
							<img src="@/assets/recycling_slices/Slice 14@2x(1).png" style="width: 12px; height: 12px" />
						</div>
						<div class="have-read">
							我已确认该卡面值准确无误
							<span style="color: #ff2f17">如面值错误,余额将无法退还!损失自行承担</span>
						</div>
					</div>
				</div>

				<div class="flex-submiss-notes" style="margin-top: 16px; align-items: center">
					<div class="card-title-type" style="width: 8%">
						<div class="card-single"></div>
					</div>
					<div class="flex-card-type" @click="determine" style="align-items: center; margin-left: 8px; margin-top: -14px">
						<div class="confirm-that-the">请确认面值无误</div>
					</div>
				</div>
			</div>
		</div>

		<div class="more-width">
			<div class="more-title">回收流程</div>
			<div class="more-text">选择京卡收 安全有保障</div>
			<div class="flex-more">
				<div>
					<img src="@/assets/Home_slices1/Group 951@2x.png" class="images" />
				</div>
				<div class="hot-group">
					<div class="hot-slices"></div>
					<div>完成实名认证</div>
				</div>
				<div>
					<img src="@/assets/Home_slices1/Group 951@2x(1).png" class="images" />
				</div>
				<div class="hot-group">
					<div class="hot-slices"></div>
					<div>等待平台认证</div>
				</div>
				<div>
					<img src="@/assets/Home_slices1/Group 951@2x(2).png" class="images" />
				</div>
				<div class="hot-group">
					<div class="hot-slices"></div>
					<div>相应资金到账</div>
				</div>
				<div>
					<img src="@/assets/Home_slices1/Group 1214@2x.png" class="images" />
				</div>
				<div class="hot-group">
					<div class="hot-slices"></div>
					<div>绑定提现账号</div>
				</div>
				<div>
					<img src="@/assets/Home_slices1/Group 1215@2x.png" class="images" />
				</div>
				<div class="hot-group">
					<div class="hot-slices"></div>
					<div>银行或支付宝</div>
				</div>
				<div>
					<img src="@/assets/Home_slices1/Group 951@2x(3).png" class="images" />
				</div>
			</div>
		</div>
		<Tabr></Tabr>
		<div>
			<Customer></Customer>
		</div>
	</div>
</template>

<script setup>
import BigNumber from 'bignumber.js';
import Customer from '@/components/customer.vue';
import Tabr from '@/components/tabr.vue';
import { onMounted, ref, nextTick, reactive } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import Landing from '@/components/landing.vue';
import Hrader from '@/components/header.vue';
import { memberUserGet, categoryList, cardList, detailsard, infraConfigOrderProtocol, cardCreate, infrafilepdf } from '@/utils/api.js';
import { handleCutZero } from '@/utils/util';
import { ElMessage, ElMessageBox } from 'element-plus';
import Popup from './components/popup.vue';
import dayjs from 'dayjs';
let showImage = ref(false);
let router = useRouter();
let route = useRoute();
let ids = ref(0);
let idst = ref(0);
let indexids = ref(99999);
let indexsT = ref(0);
let marListRef = ref([]);
let dataListSkip = ref([]);
let cardDetails = ref([]);
let price = ref('');
let detailInfo = ref({});
let text = ref('');
let ruleDes = ref('');
let pdfCodef = ref('');
let flon = ref(true);
let flon2 = ref(true);
let flon3 = ref(true);
let hasPwd = ref(1);
let hasEnd = ref();
let imageList = ref([]);
let state = reactive({
	model: {
		batchCodes: '',
		code: '',
		pwd: '',
		endDate: '',
		codes: []
	}
});
let dataList = ref([{ title: '批量提交' }, { title: '单张提交' }]);
const skipClick = (item) => {
	router.push({ path: item });
};
const into = async () => {
	let res = await categoryList();
	marListRef.value = res.data;
	ids.value = res.data[0].id;
	if (route.query.categoryId) {
		ids.value = route.query.categoryId;
	}
	cardListInfo();
};
const membMoubeClick = () => {
	showImage.value = !showImage.value;
};
const cardListInfo = async () => {
	let ref = await cardList({
		categoryId: ids.value
	});
	dataListSkip.value = ref.data;
	text.value = dataListSkip.value[0].remark;
	ruleDes.value = dataListSkip.value[0].ruleDes;
	if (route.query.categoryId) {
		let index = dataListSkip.value.findIndex((item) => item.id == route.query.ids);
		idst.value = index;
		text.value = dataListSkip.value[idst.value].remark;
		ruleDes.value = dataListSkip.value[idst.value].ruleDes;
	}
	hasEnd.value = dataListSkip.value[idst.value].hasEnd;
	queryCardDetails();
};
const cardListInfo1 = async () => {
	let ref = await cardList({
		categoryId: ids.value
	});
	dataListSkip.value = ref.data;
	hasEnd.value = dataListSkip.value[0].hasEnd;
	text.value = dataListSkip.value[0].remark;
	ruleDes.value = dataListSkip.value[0].ruleDes;
	hasPwd.value = dataListSkip.value[0].hasPwd;
	queryCardDetails();
};
const seletcClick = (id) => {
	ids.value = id;
	idst.value = 0;
	cardListInfo1();
	indexids.value = 99999;
	state.model.endDate = '';
	price.value = '';
};
const paddlickey = (index) => {
	idst.value = index;
	indexids.value = 99999;
	price.value = '';
	text.value = dataListSkip.value[index].remark;
	ruleDes.value = dataListSkip.value[index].ruleDes;
	hasPwd.value = dataListSkip.value[index].hasPwd;
	hasEnd.value = dataListSkip.value[idst.value].hasEnd;
	console.log(1111111111111, dataListSkip.value);
	console.log(1111111111111, hasEnd.value);
	queryCardDetails();
};
// 兑换说明格式化
const formatCardDes = (des) => {
	if (!des) {
		return '';
	}
	const tmp = des.replaceAll('\r', '<br/>').replaceAll('\n', '<br/>');
	return tmp;
};
const queryCardDetails = async () => {
	const { code, data } = await detailsard({
		cardId: dataListSkip.value[idst.value].id
	});
	if (code !== 0) {
		return;
	}
	data.forEach((item) => {
		if (item.recycleType === 'rate') {
			let oRate = new BigNumber(item.price).dividedBy(100);
			let rate = '';
			if (item.channelCode == 'zheka') {
				rate = new BigNumber(item.zhekaRate).plus(oRate);
			} else {
				rate = new BigNumber(item.recycleRate).plus(oRate);
				// rate = new BigNumber(item.recycleRate);
			}
			if (item.vipRate) {
				rate = new BigNumber(item.vipRate);
			}
			if (rate.comparedTo(1) === 1) {
				rate = new BigNumber(1);
			}
			item.price = new BigNumber(item.name).multipliedBy(rate).toFixed(4);
			item.rate = new BigNumber(rate).times(100).toFixed(2);
		} else if (item.recycleType === 'raterang') {
			let oRate = new BigNumber(item.price).dividedBy(100);
			let rate = new BigNumber(item.minRecycleRate).plus(oRate);
			if (rate.comparedTo(1) === 1) {
				rate = new BigNumber(1);
			}
			item.price = new BigNumber(item.name).multipliedBy(rate).toFixed(4);
			item.rate = new BigNumber(rate).times(100).toFixed(2);
		} else if (item.recycleType === 'fixed') {
			let rate = new BigNumber(item.price).plus(oRate);
			item.rate = new BigNumber(rate).times(100).toFixed(2);
		} else if (item.recycleType === 'customfacevalue' || item.type === 2) {
			if (item.channelCode == 'zheka') {
				item.valueList = JSON.parse(item.zhekaCustomFaceValueRateInfo);
			} else {
				item.valueList = JSON.parse(item.customFaceValueRateInfo);
			}
			item.name = '自定义';
			item.type = 2;
		}
	});
	cardDetails.value = data;
	console.log(cardDetails.value);
};
const recyClick = (index) => {
	indexids.value = index;
};
const flonClick = (index) => {
	if (index == 1) {
		flon.value = !flon.value;
		console.log(1111, index);
	} else if (index == 2) {
		flon2.value = !flon2.value;
	} else {
		flon3.value = !flon3.value;
	}
};
const flexCardType = (index) => {
	indexsT.value = index;
};
const inpuSarptPlace = () => {
	let r = /^[0-9]*$/g;
	if (!price.value) {
		return false;
	}
	if (!r.test(price.value)) {
		ElMessage({
			message: '请输入1-99999的整数',
			type: 'error'
		});
		price.value = '';
		return false;
	}
	customPriceChange(price.value);
};
let bRate = null;
let rate = null;
let rapas = null;
function customPriceChange(price) {
	detailInfo.value = cardDetails.value[0];
	if (detailInfo.value.valueList) {
		for (let i = 0; i < detailInfo.value.valueList.length; i++) {
			let c = detailInfo.value.valueList[i];
			if (price >= c.min && price <= c.max) {
				if (c.vipRate) {
					rate = new BigNumber(c.vipRate);
					bRate = new BigNumber(0);
				} else {
					rate = new BigNumber(c.rate);
					bRate = new BigNumber(c.price).dividedBy(100);
				}
				rapas = new BigNumber(c.rate);
			}
		}
		console.log(rate);
		rate = rate.plus(bRate);
	}
	if (null == rate) {
		rate = new BigNumber(detailInfo.value.price).dividedBy(100);
	}
	let data = {
		...detailInfo.value,
		name: price,
		price: rate.multipliedBy(price).toFixed(4),
		customerPrice: price
	};
	cardDetails.value[0].price = data.price;
	cardDetails.value[0].recycleRate = rapas;
}
const batchCodeChangeCode = () => {
	let e = state.model.code;
	nextTick(() => {
		let val = e.toString();
		val = val.replace(/[^A-Za-z0-9\s]/g, ''); //清除"数字"和"."以外的字符
		val = val.replace(/\s+/g, '.'); //只保留第一个. 清除多余的
		e = val;
		state.model.code = val;
	});
};
const batchCodeChangePwd = () => {
	let e = state.model.pwd;
	let val = e.toString();
	if (dataListSkip.value[idst.value]?.hasPwd == 1 || ids.value!=3) {
	  nextTick(() => {
	  	val = val.replace(/[^A-Za-z0-9\s]/g, ''); //清除"数字"和"."以外的字符
	  	val = val.replace(/\s+/g, '.'); //只保留第一个. 清除多余的
	  	e = val;
	  	state.model.pwd = val;
	  });	
	}else{
		nextTick(() => {
			val = val.replace(/\s/g, ""); //只保留第一个. 清除多余的
			e = val;
			state.model.pwd = val;
		});	
	}
};
const batchCodeChange = () => {
	if (dataListSkip.value[idst.value]?.hasPwd == 1 || ids.value!=3) {
		let e = state.model.batchCodes;
		let reg1 = /[^A-Za-z0-9\s]/g;
		let reg2 = /\s+/g;
		let lines = e.split('\n');
		let codes = [];
		let newCon = [];
		lines.forEach((line) => {
			line = line.replaceAll(reg1, '').replaceAll(reg2, ' ');
			newCon.push(line);
			let codeObj = line.split(' ');
			codes.push({
				code: codeObj[0],
				pwd: codeObj[1]
			});
		});
		nextTick(() => {
			state.model.batchCodes = newCon.join('\n');
			state.model.codes = codes;
		});	
	}else{
		let e = state.model.batchCodes;
		let reg1 = /\s/g;
		let reg2 = /\s/g;
		let lines = e.split('\n');
		let codes = [];
		let newCon = [];
		lines.forEach((line) => {
			line = line.replaceAll(reg1, '').replaceAll(reg2, '');
			newCon.push(line);
			let codeObj = line.split(' ');
			codes.push({
				code: codeObj[0],
				pwd: codeObj[1]
			});
		});
		nextTick(() => {
			state.model.batchCodes = newCon.join('\n');
			state.model.codes = codes;
		});
	}
};
const info = async () => {
	let ref = await infraConfigOrderProtocol();
	pdfCodef.value = ref.data;
	infoPdf();
};
const Jump = () => {
	membMoubeClick();
};
const determine = async () => {
	if (flon.value || flon2.value || flon3.value) {
		ElMessage({
			message: '请勾选转让协议',
			type: 'error'
		});
		return false;
	}
	let cardNoList = [];
	let endDate = '';
	if (indexsT.value == 1) {
		if (dataListSkip.value[idst.value]?.hasPwd == 1) {
			if (!state.model.code) {
				ElMessage({
					message: '请输入卡号',
					type: 'error'
				});
				return false;
			}
		}
		if (!state.model.pwd) {
			ElMessage({
				message: '请输入卡密',
				type: 'error'
			});
			return false;
		}
		cardNoList.push({
			code: state.model.code,
			pwd: state.model.pwd
		});
	} else {
		if (!state.model.codes[0]?.code) {
			ElMessage({
				message: '请输入卡号卡密',
				type: 'error'
			});
			return false;
		}
		if (dataListSkip.value[idst.value]?.hasPwd == 1) {
			// cardNoList=[];
			cardNoList = state.model.codes;
			// state.model.codes.forEach(item=>{
			//  if(item.code){
			// 	 cardNoList.push({code:item.code,pwd:item.pwd});
			//  }
			// })
		} else {
			cardNoList = [];
			state.model.codes.forEach((item) => {
				if (item.code) {
					cardNoList.push({ pwd: item.code });
				}
			});
		}
	}
	if (indexids.value == 99999) {
		ElMessage({
			message: '请选择面值',
			type: 'error'
		});
		return false;
	}
	if (indexids.value == 99999) {
		ElMessage({
			message: '请选择面值',
			type: 'error'
		});
		return false;
	}
	if (state.model.endDate) {
		endDate = dayjs(state.model.endDate).format('YYYY-MM-DD');
	}
	let res = await cardCreate({
		cardId: dataListSkip.value[idst.value].id,
		cardDetailId: cardDetails.value[indexids.value].id,
		cardNoList: cardNoList,
		categoryId: ids.value,
		customerPrice: price.value,
		endDate: endDate
	});
	console.log(!res.data);
	if (res.msg) {
		console.log(!res.data);
		ElMessage({
			message: res.msg,
			type: 'error'
		});
		return false;
	} else {
		ElMessage({
			message: '添加成功',
			type: 'success'
		});
		setTimeout(() => {
			router.push(
				{
					path: 'personalCenter',
					query: {
						ids: 7
					}
				},
				1000
			);
		});
	}
};
const infoConst = async () => {
	let res = await memberUserGet();
	localStorage.setItem('information', JSON.stringify(res.data));
	if (res.data?.realType < 2) {
		ElMessageBox.confirm('为保障您的合法权益以及平台合法运营，请进行实名认证，未认证不能进行卡券核销。', '提示', {
			distinguishCancelAndClose: true,
			confirmButtonText: '确定',
			cancelButtonText: '取消'
		})
			.then(() => {
				router.push({
					path: 'personalCenter',
					query: {
						ids: 9
					}
				});
			})
			.catch((ref) => {
				router.go(-1);
			});
	}
};
const infoPdf = async () => {
	const ret = await infrafilepdf({
		path: pdfCodef.value.value
	});
	imageList.value = ret.data;
};
const organizeClick = () => {
	if (!state.model.batchCodes) {
		ElMessage({
			message: '请输入卡号卡密',
			type: 'error'
		});
	} else {
		if (dataListSkip.value[idst.value]?.hasPwd != 1) {
			ElMessage({
				message: '已整理卡号卡密',
				type: 'success'
			});
			let batchCodeString = [];
			let codesString = [];
			let codesBatch = [];
			state.model.codes.forEach((item, index) => {
				if (item.code) {
					batchCodeString.push(item.code);
				}
				if (item.pwd) {
					batchCodeString.push(item.pwd);
				}
			});
			console.log(batchCodeString);
			let pairs = [];
			for (let i = 0; i < batchCodeString.length; i++) {
				pairs.push([batchCodeString[i]]);
			}
			console.log(pairs);
			pairs.forEach((item, index) => {
				codesString.push(item.join(' '));
				codesBatch.push({
					code: item[0]
				});
			});
			state.model.batchCodes = codesString.join('\n');
			state.model.codes = codesBatch;
			return false;
		}
		ElMessage({
			message: '已整理卡号卡密',
			type: 'success'
		});
		let batchCodeString = [];
		let codesString = [];
		let codesBatch = [];
		state.model.codes.forEach((item, index) => {
			if (item.code) {
				batchCodeString.push(item.code);
			}
			if (item.pwd) {
				batchCodeString.push(item.pwd);
			}
		});
		console.log(batchCodeString);
		let pairs = [];
		for (let i = 0; i < batchCodeString.length; i += 2) {
			pairs.push([batchCodeString[i], batchCodeString[i + 1]]);
		}
		pairs.forEach((item, index) => {
			codesString.push(item.join(' '));
			codesBatch.push({
				code: item[0],
				pwd: item[1]
			});
		});
		state.model.batchCodes = codesString.join('\n');
		state.model.codes = codesBatch;
	}
};
const organizeClick1 = () => {
	if (!state.model.batchCodes) {
		return false;
	} else {
		if (dataListSkip.value[idst.value]?.hasPwd != 1) {
			let batchCodeString = [];
			let codesString = [];
			let codesBatch = [];
			state.model.codes.forEach((item, index) => {
				if (item.code) {
					batchCodeString.push(item.code);
				}
				if (item.pwd) {
					batchCodeString.push(item.pwd);
				}
			});
			console.log(batchCodeString);
			let pairs = [];
			for (let i = 0; i < batchCodeString.length; i++) {
				pairs.push([batchCodeString[i]]);
			}
			console.log(pairs);
			pairs.forEach((item, index) => {
				codesString.push(item.join(' '));
				codesBatch.push({
					code: item[0]
				});
			});
			state.model.batchCodes = codesString.join('\n');
			state.model.codes = codesBatch;
			return false;
		}
		let batchCodeString = [];
		let codesString = [];
		let codesBatch = [];
		state.model.codes.forEach((item, index) => {
			if (item.code) {
				batchCodeString.push(item.code);
			}
			if (item.pwd) {
				batchCodeString.push(item.pwd);
			}
		});
		console.log(batchCodeString);
		let pairs = [];
		for (let i = 0; i < batchCodeString.length; i += 2) {
			pairs.push([batchCodeString[i], batchCodeString[i + 1]]);
		}
		pairs.forEach((item, index) => {
			codesString.push(item.join(' '));
			codesBatch.push({
				code: item[0],
				pwd: item[1]
			});
		});
		state.model.batchCodes = codesString.join('\n');
		state.model.codes = codesBatch;
	}
};
onMounted(() => {
	infoConst();
	into();
	info();
});
</script>

<style lang="scss" scoped>
.head-guidance {
	width: 100%;
	height: 70px;
	background: #ffffff;
	border-radius: 0px 0px 0px 0px;
	position: fixed;
	top: 0;
	z-index: 111;
	.head-guidance-flex {
		width: 100%;
		display: flex;
		justify-content: space-between;
		.image {
			width: 106px;
			height: 40px;
			margin-top: 15px;
			margin-left: 160px;
		}
	}
	.head-right {
		display: flex;
		margin-right: 104px;

		.head-right-flex {
			display: flex;
			align-items: center;
			margin-top: 12px;
			margin-left: 36px;

			.home-right {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 16px;
				color: #333333;
				text-align: left;
				font-style: normal;
				text-transform: none;
				margin-left: 6px;
			}
		}

		.head-right-flex:hover {
			cursor: pointer;
		}

		.head-right-flex1:hover {
			cursor: pointer;
		}

		.head-right-flex1 {
			display: flex;
			align-items: center;
			padding: 11px 16px;
			background: #ff3333;
			border-radius: 74px 74px 74px 74px;
			margin-top: 13px;

			.home-right {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 16px;
				color: #fff;
				text-align: left;
				font-style: normal;
				text-transform: none;
				margin-left: 6px;
			}
		}
		.frame-flex {
			height: 18px;
			border-right: 1px solid #dddddd;
			margin-top: 26px;
			margin-left: 22px;
			padding-right: 44px;
		}
	}
}

.more-width {
	width: 1280px;
	padding-top: 41px;
	padding-bottom: 45px;
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	margin: auto;
	margin-top: 20px;
}
.more-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 22px;
	color: #333333;
	text-align: center;
	font-style: normal;
	text-transform: none;
}
.flex-more {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-left: 44px;
	margin-top: 30px;
}
.more-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	text-align: center;
	font-style: normal;
	margin-top: 6px;
	text-transform: none;
}
.hot-group {
	white-space: nowrap;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 11px;
	color: #000000;
	font-style: normal;
	text-transform: none;
	padding-bottom: 7px;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: -10px;
}
.hot-slices {
	margin: auto;
	width: 50px;
	height: 0px;
	border-top: 2px solid #eeeeee;
	padding-top: 10px;
}

.images {
	width: 85%;
	height: auto;
}
.rectangle {
	width: 100%;
	height: 52px;
	background: #ffffff;
	border-radius: 0px 0px 0px 0px;
}
.rectangle-with {
	width: 1280px;
	margin: auto;
	height: 52px;
}

.flex-rectange {
	display: flex;
	align-items: center;
	height: 52px;
	margin-left: 22px;
}

.current-recy {
	margin-left: 7px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}

.select-card-type {
	width: 1280px;
	margin: auto;
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	margin-top: 20px;
}

.submission-notes {
	padding: 20px 46px;
}

.flex-submiss-notes {
	display: flex;
}

.select-recycling-type {
	background: #f2f2f2;
	border-radius: 30px 30px 30px 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 10px 22px;
	margin-left: 20px;
	margin-top: 20px;
}

.select-recycling-type:hover{
	cursor: pointer;
}

.select-recycling-type1 {
	background: #ff3333;
}

.flex-card-type {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	margin-left: 5px;
	width: 94%;
}

.flex-card-type-warp {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	margin-left: 5px;
	width: 94%;
	margin-top: -16px;
	// overflow: hidden;
	// overflow-x: auto;
}

.flex-card-type:hover {
	cursor: pointer;
}

.card-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 500;
	font-size: 16px;
	margin-left: 12px;
	font-style: normal;
	text-transform: none;
	color: #000000;
}

.card-title1 {
	color: #ffffff;
}

.border-top-card {
	width: 100%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 20px;
	padding-top: 20px;
}

.card-title-type {
	width: 7%;
}
.card-single {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}
.card-make {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 12px;
	color: #b8b8b8;
	text-align: left;
	font-style: normal;
	text-transform: none;
}

.flex-card-type-warp::-webkit-scrollbar {
  display: none;
}


.card-recycling {
	margin-left: 24px;
	margin-top: 14px;
	width: calc(14% - 24px);
	background: #ffffff;
	border-radius: 7px;
	border: 1px solid #eeeeee;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.card-recycling1 {
	background: #ffe6e6;
	border: 2px solid #ff3333;
}
.fold-card {
	position: absolute;
	top: 0;
	left: 0;
	width: 37px;
	height: 17px;
	background: #ff3333;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 11px;
	color: #ffffff;
	line-height: 17px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	border-radius: 5px 0px;
}
.vimage {
	width: 100%;
	height: 80px;
	margin-top: 14px;
}
.voctor-detach {
	// font-family: PingFang SC, PingFang SC;
	font-family: 'Microsoft YaHei', Arial, sans-serif;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-top: 6px;
	width: 120px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.voctor-detach1 {
	font-family: PingFang SC, PingFang SC;
	font-weight: 500;
	font-size: 15px;
	color: #ff3333;
}
.card-recycling:hover {
	.voctor-detach {
		// white-space: normal;
	}
}
.card-price {
	font-family: PingFang SC, PingFang SC;
	font-weight: 500;
	font-size: 24px;
	color: #333333;
	text-align: center;
	font-style: normal;
	text-transform: none;
}

.flex-price {
	display: flex;
	align-items: center;
}

.card-price1 {
	color: #ff3333;
}
.flex-fold {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 12px;
	color: #ff3333;
	font-style: normal;
	text-transform: none;
}
.bordr-fold {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 12px;
	color: #eeeeee;
	font-style: normal;
	text-transform: none;
	padding: 0px 3px;
	padding-left: 5px;
}
.font-fold {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 12px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}

.inputSarpt {
	width: 70%;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #000;
	font-style: normal;
	background-color: transparent;
	border: none;
}

.placeholder {
	width: 70%;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #aaaaaa;
	font-style: normal;
	background-color: transparent;
	border: none;
}
.card-price-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 500;
	font-size: 16px;
	font-style: normal;
	text-transform: none;
}
.card-price-title1 {
	color: #ff3333;
}
.card-text-price {
	width: 100%;
	margin-left: 2%;
	background: #fff5f5;
	border-radius: 4px 4px 4px 4px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #db8a8a;
	line-height: 16px;
	text-align: justified;
	font-style: normal;
	text-transform: none;
	margin-top: 16px;
}

.border-width{
	background: #FFFFFF;
	border-radius: 4px 4px 4px 4px;
	border: 1px solid #EEEEEE;
	height: 300px;
}

.textarea {
	width: 50%;
	height: 300px;
	margin-top: 10px;
	background: #ffffff;
	border-radius: 4px 4px 4px 4px;
	border: 1px solid #eeeeee;
	padding: 0px 10px;
	border: none;
}

textarea:focus {
	outline: none;
	border: none;
}

.flex-card-margin {
	width: 15%;
	height: 42px;
	border-radius: 4px 4px 4px 4px;
	border: 1px solid #ff2f17;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	// background: #ffffff;
	// color: #ff2f17;
	background: #ff2f17;
	color: #fff;
	line-height: 42px;
	letter-spacing: 2px;
	text-align: center;
	font-style: normal;
	text-transform: none;
}

.flex-card-margin:hover {
	background: #ffffff;
	color: #ff2f17;
}

.flex-card-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-left: 22px;
}
.text-span {
	color: #ff2f17;
	padding: 0px 5px;
}

.flex-slice {
	width: 24px;
	height: 24px;
	background: #ff2f17;
	border-radius: 3px 3px 3px 3px;
	margin-top: 16px;
	border: 1px solid #eeeeee;
	display: flex;
	align-items: center;
	justify-content: center;
}
.have-read {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	margin-left: 11px;
	margin-top: 18px;
	font-style: normal;
	text-transform: none;
}

.confirm-that-the {
	width: 194px;
	height: 53px;
	background: #ff2f17;
	border-radius: 4px 4px 4px 4px;
	border: 1px solid #ff2f17;
	line-height: 53px;
	text-align: center;
	margin-top: 41px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 18px;
	color: #ffffff;
	letter-spacing: 2px;
	font-style: normal;
	text-transform: none;
}

.flex-slice1 {
	background: #ffffff;
	border-radius: 3px 3px 3px 3px;
	border: 1px solid #eeeeee;
}

.input {
	width: 100%;
	height: 20px;
	margin-top: 10px;
	background: #ffffff;
	border-radius: 4px 4px 4px 4px;
	border: 1px solid #eeeeee;
	padding: 10px 10px;
	font-size: 14px;
}
.input::placeholder {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
}
.input:focus {
	outline: none;
	border: 1px solid #eeeeee;
}

.margin-width{
	width: 40%;
	height: 300px;
	background: #FBFBFB;
	margin-left: auto;
	margin-top: -10px;
}
</style>
